<footer>
  <div class="inner wrap">
    <div class="footer-info-box">
      <div class="left-content">
        <div class="copyright-box">
          <div class="copyright-txt-box">
            <span>Copyright © 2025 한 다인 등. All rights reserved.</span>
          </div>
        </div>
        <div class="info-box">
          <a class="info-txt-box" [routerLink]="['/legal-notice']">
            책임의 한계와 법적인 고지
          </a>
        </div>
      </div>

      <div class="right-content">
        <div class="footer-image appstore-download"
        (click)="openAppStoreLink()"></div>
        <div class="footer-image android-download" 
        (click)="openAndroidLink()"></div>
      </div>
    </div>
  </div>
</footer>

<!-- a class="temp-btn" (click)="ToggleLargeMode()">라지모드</a -->
